export default __webpack_public_path__ + "h3.png";